import { User } from './user';

export class AccessMapping<T> {
  user: User;
  access: T;
  lastUpdateDate: Date;
  lastUpdatedBy: User;
}
